module.exports = __webpack_public_path__ + "0966ba42890a56dd20aea8a107d21d19.svg";